/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Account } from "./Account";
export const AccountResponse = core.serialization.object({
    data: Account,
});
